export class CatalogConstants {

    static get usedVehicleOperationTypeId(){
        return 7;
    }

    static get newVehicleOperationTypeId(){
        return 6;
    }
} 